"use strict";
require.context("../images", true);
import "stylesheets/decidim/system/application.scss";
